import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_@upstash+redis@1.34.9_@vercel+blob@1.0_5wlfb5gpmnln2tkjyrubehpdsq/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/vercel/path0/middleware/maintenance.global.ts";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_@upstash+redis@1.34.9_@vercel+blob@1.0_5wlfb5gpmnln2tkjyrubehpdsq/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}